import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getLands(companyId) {
	return dataTransferWrap(
		ModulesMap.LANDS,
		dtConfig[ModulesMap.LANDS].getLands,
		{
			urlParams: {
				companyId,
			},
		},

	)
}
function getBaseLands(companyId) {
	return dataTransferWrap(
		ModulesMap.LANDS,
		dtConfig[ModulesMap.LANDS].getBaseLands,
		{
			urlParams: {
				companyId,
			},
		},

	)
}
function getExtendLands(companyId) {
	return dataTransferWrap(
		ModulesMap.LANDS,
		dtConfig[ModulesMap.LANDS].getExtendLands,
		{
			urlParams: {
				companyId,
			},
		},

	)
}

function getLand(companyId, landId) {
	return dataTransferWrap(ModulesMap.LANDS, dtConfig[ModulesMap.LANDS].getLand, {
		urlParams: {
			companyId,
			landId,
		},
	})
}

function createLand(companyId, payload) {
	return dataTransferWrap(ModulesMap.LANDS, dtConfig[ModulesMap.LANDS].createLand, {
		urlParams: {
			companyId,
		},
		...payload,
	})
}

function putLand(companyId, landId, payload) {
	return dataTransferWrap(ModulesMap.LANDS, dtConfig[ModulesMap.LANDS].putLand, {
		urlParams: {
			companyId,
			landId,
		},
		...payload,
	})
}

function patchLand(companyId, landId, payload) {
	return dataTransferWrap(ModulesMap.LANDS, dtConfig[ModulesMap.LANDS].patchLand, {
		urlParams: {
			companyId,
			landId,
		},
		...payload,
	})
}

function deleteLand(companyId, landId) {
	return dataTransferWrap(ModulesMap.LANDS, dtConfig[ModulesMap.LANDS].deleteLand, {
		urlParams: {
			companyId,
			landId,
		},
	})
}

function getLandPreview(companyId, landId) {
	return dataTransferWrap(ModulesMap.LANDS, dtConfig[ModulesMap.LANDS].getLandPreview, {
		urlParams: {
			companyId,
			landId,
		},
	})
}

function getLandPopup(companyId, landId) {
	return dataTransferWrap(ModulesMap.LANDS, dtConfig[ModulesMap.LANDS].getLandPopup, {
		urlParams: {
			companyId,
			landId,
		},
	})
}

export default {
	getLands,
	getBaseLands,
	getExtendLands,
	getLand,
	createLand,
	putLand,
	patchLand,
	deleteLand,
	getLandPreview,
	getLandPopup,
}
